import { Factory, trait } from 'miragejs'
import { faker } from '@faker-js/faker'
import { subDays, format } from 'date-fns'
import { createOrUpdateSchoolSubscriptionUtilisation } from 'teacher-ui-client/mirage/helpers/subscriptions'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

// This does not need to be done via a trait. Refactor to usages to just set attribute
function countryCodeTrait(countryCode) {
  return trait({
    afterCreate(school, _server) {
      school.update({ countryCode })
    },
  })
}

export default Factory.extend({
  name() {
    return faker.company.name()
  },

  schoolCode() {
    return faker.company.name().toUpperCase()
  },

  isHomeschool() {
    return false
  },

  usesExternalAuthentication() {
    return false
  },

  usesExternalRostering() {
    return false
  },

  usesExternalAccountProvisioning() {
    return false
  },

  // Default country code returned by gravity
  countryCode() {
    return 'AU'
  },

  state() {
    return faker.location.state()
  },

  AU: countryCodeTrait('AU'),
  NZ: countryCodeTrait('NZ'),
  KR: countryCodeTrait('KR'),
  GB: countryCodeTrait('GB'),
  US: countryCodeTrait('US'),
  CA: countryCodeTrait('CA'),
  IN: countryCodeTrait('IN'),

  /**
   * Note that the this trait creates a school-subscription, it does not create a subscription.
   */
  mathsSubscription: trait({
    afterCreate(school, server) {
      server.create('school-subscription', {
        school,
        subscriptionType: SubscriptionType.Maths,
      })
      createOrUpdateSchoolSubscriptionUtilisation(server, school.id, { subscriptionType: SubscriptionType.Maths })
    },
  }),

  readingSubscription: trait({
    afterCreate(school, server) {
      server.create('school-subscription', {
        school,
        subscriptionType: SubscriptionType.Reading,
      })
      createOrUpdateSchoolSubscriptionUtilisation(server, school.id, { subscriptionType: SubscriptionType.Reading })
    },
  }),

  overCapacityReadingSubscription: trait({
    afterCreate(school, server) {
      server.create('school-subscription', {
        school,
        subscriptionType: SubscriptionType.Reading,
      })
      createOrUpdateSchoolSubscriptionUtilisation(server, school.id, {
        subscriptionType: SubscriptionType.Reading,
        studentCount: 200,
        licenceCount: 100,
        remainingLicences: -100,
      })
    },
  }),

  writingSubscription: trait({
    afterCreate(school, server) {
      server.create('school-subscription', {
        school,
        subscriptionType: SubscriptionType.Writing,
      })
      createOrUpdateSchoolSubscriptionUtilisation(server, school.id, { subscriptionType: SubscriptionType.Writing })
    },
  }),

  mathsSubscriptionExpired: trait({
    afterCreate(school, server) {
      const now = new Date()
      const endDate = format(subDays(now, 10), 'yyyy-MM-dd')
      const startDate = format(subDays(now, 20), 'yyyy-MM-dd')
      server.create('school-subscription', {
        school,
        subscriptionType: SubscriptionType.Maths,
        startDate,
        endDate,
      })
      createOrUpdateSchoolSubscriptionUtilisation(server, school.id, { subscriptionType: SubscriptionType.Maths })
    },
  }),

  mathseedsUpsell: trait({
    afterCreate(school, server) {
      const now = new Date()
      const endDate = '2024-06-20'
      const startDate = format(subDays(now, 20), 'yyyy-MM-dd')
      server.create('school-subscription', {
        school,
        subscriptionType: SubscriptionType.Maths,
        startDate,
        endDate,
        subscriptionName: 'ms_free_access_may_24',
      })
      createOrUpdateSchoolSubscriptionUtilisation(server, school.id, { subscriptionType: SubscriptionType.Maths })
    },
  }),

  readingSubscriptionExpired: trait({
    afterCreate(school, server) {
      const now = new Date()
      const endDate = format(subDays(now, 10), 'yyyy-MM-dd')
      const startDate = format(subDays(now, 20), 'yyyy-MM-dd')
      server.create('school-subscription', {
        school,
        subscriptionType: SubscriptionType.Reading,
        startDate,
        endDate,
      })
      createOrUpdateSchoolSubscriptionUtilisation(server, school.id, { subscriptionType: SubscriptionType.Reading })
    },
  }),

  withPartners: trait({
    afterCreate(school, server) {
      server.create('school-partner', { subscriptionType: SubscriptionType.Reading, school })
      server.create('school-partner', { subscriptionType: SubscriptionType.Maths, school })
      server.create('school-partner', { subscriptionType: SubscriptionType.Writing, school })
    },
  }),
})
